function About() {
    return <div style={{marginLeft: 20}}>
                <p>Provided by OPE Group Service Desk.</p>
                <p>If you experience problems please email ServiceDesk@constellationdealer.com</p>
        </div>;
}
  
  export default About;